import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from './shell/Layout';
import { Home } from './pages/Home';
import { NotFound } from './pages/NotFound';
import { SigningIn } from './pages/SigningIn';
import { SignedOut } from './pages/SignedOut';
import { Login } from './pages/Login';
import { CommerceOrders } from './pages/commerce/Orders';
import { CommerceOrderDetail } from './pages/commerce/OrderDetail';
// Products / Inventory now render the Sage-catalog pages backed by the
// /v1/commerce/catalog/* endpoints (product_catalog + inventory_on_hand views).
// The prior Sage-CI_Item Products page (Products.tsx / ProductDetailStub.tsx)
// and the Inventory stub (InventoryStub.tsx) remain in the tree so reverting is
// a one-line import swap.
// import { CommerceInventoryStub } from './pages/commerce/InventoryStub';
// import { CommerceProducts } from './pages/commerce/Products';
// import { CommerceProductDetailStub } from './pages/commerce/ProductDetailStub';
import { CommerceCatalogProducts } from './pages/commerce/CatalogProducts';
import { CommerceCatalogProductDetail } from './pages/commerce/CatalogProductDetail';
import { CommerceCatalogInventory } from './pages/commerce/CatalogInventory';
import { CommercePartnersStub } from './pages/commerce/PartnersStub';
import { CommerceReportsStub } from './pages/commerce/ReportsStub';
import { CrmAccounts } from './pages/crm/Accounts';
import { CrmAccountDetail } from './pages/crm/AccountDetail';
import { CrmPipeline } from './pages/crm/Pipeline';
import { CrmOpportunityDetail } from './pages/crm/OpportunityDetail';
import { CrmScorecard } from './pages/crm/Scorecard';
import { FaireDashboard } from './pages/faire/Dashboard';
import { FaireReports } from './pages/faire/Reports';
import { FaireErrors } from './pages/faire/Errors';
import { FaireShipments } from './pages/faire/Shipments';
import { Projects } from './pages/projects/Projects';
import { NetmonSites } from './pages/netmon/Sites';
import { NetmonSiteDetail } from './pages/netmon/SiteDetail';
import { NetmonSnipeItReconcile } from './pages/netmon/SnipeItReconcile';
import { CockpitOps } from './pages/it/CockpitOps';
import { Agents } from './pages/it/Agents';
import { AgentDetail } from './pages/it/AgentDetail';
import { CounterValidation } from './pages/it/CounterValidation';
import { Telemetry } from './pages/it/Telemetry';
import { Adoption } from './pages/it/Adoption';
import { NotificationLog } from './pages/it/NotificationLog';
import { Changelog } from './pages/it/Changelog';
import { ServiceDesk } from './pages/it/servicedesk/ServiceDesk';
import { Ticket as ServiceDeskTicket } from './pages/it/servicedesk/Ticket';
import { Settings as ServiceDeskSettings } from './pages/it/servicedesk/Settings';
import { KnowledgeBase as ServiceDeskKb } from './pages/it/servicedesk/KnowledgeBase';
import { KbArticle as ServiceDeskKbArticle } from './pages/it/servicedesk/KbArticle';
import { UserActivityDetail } from './pages/it/UserActivityDetail';
import { ApiDocs } from './pages/it/ApiDocs';
import { RetailFleetMap } from './pages/retail/FleetMap';
import { RetailAllocation } from './pages/retail/Allocation';
import { RetailPerformance } from './pages/retail/Performance';
import { RetailLeakage } from './pages/retail/Leakage';
import { RetailItemSales } from './pages/retail/ItemSales';
import { Reports } from './pages/reports/Reports';
import { CoAsList } from './pages/compliance/CoAsList';
import { MissingCoas } from './pages/compliance/MissingCoas';
import { MissingCoaDetail } from './pages/compliance/MissingCoaDetail';
import { CoaDetail } from './pages/compliance/CoaDetail';
import { InvoicesList } from './pages/finance/InvoicesList';
import { InvoiceDetail } from './pages/finance/InvoiceDetail';
import { AccessConsole } from './pages/admin/AccessConsole';
import { SettingsPage } from './pages/settings/Settings';
import { ChangelogPage } from './pages/settings/ChangelogPage';
import { ConnectPartners } from './pages/connect/Partners';
import { ConnectPartnerDetail } from './pages/connect/PartnerDetail';
import { ConnectPricing } from './pages/connect/Pricing';
import { ConnectCatalog } from './pages/connect/Catalog';
import { ConnectAgreements } from './pages/connect/Agreements';
import { ConnectAdoption } from './pages/connect/Adoption';
import { Today } from './pages/stores/Today';
import { StoreHome } from './pages/stores/StoreHome';
import { InventoryCount } from './pages/stores/InventoryCount';
import { CountSession } from './pages/stores/CountSession';
import { InventoryVariance } from './pages/stores/InventoryVariance';
import { InventoryImports } from './pages/stores/InventoryImports';
import { InventoryHistory } from './pages/stores/InventoryHistory';
import { StoreUsers } from './pages/stores/StoreUsers';
import { StoreTablets } from './pages/stores/StoreTablets';
import { StoreChecklist } from './pages/stores/StoreChecklist';
import { StoreInfo } from './pages/stores/StoreInfo';
import { StoreFiles } from './pages/stores/StoreFiles';
import { StorePaperwork } from './pages/stores/StorePaperwork';
import { ContentList } from './pages/stores/ContentList';
import { ContentEditor } from './pages/stores/ContentEditor';
import { HqScorecard } from './pages/stores/HqScorecard';
import { DoorTimes } from './pages/stores/DoorTimes';
import { EmployeePurchases } from './pages/stores/EmployeePurchases';
import { UnpostedActivity } from './pages/reports/UnpostedActivity';
import { Loyalty } from './pages/reports/Loyalty';
import { StoreAnalytics } from './pages/reports/StoreAnalytics';
import { OnOrder } from './pages/reports/OnOrder';
import { FleetHourly } from './pages/reports/FleetHourly';
import { CashCredit } from './pages/reports/CashCredit';
import { Trailing12 } from './pages/reports/Trailing12';
import { SalesTax } from './pages/reports/SalesTax';
import { GiftCards } from './pages/reports/GiftCards';
import { GlExports } from './pages/reports/GlExports';
import { ItemFile } from './pages/reports/ItemFile';
import { HqQuestions } from './pages/stores/HqQuestions';
import { HqPulse } from './pages/stores/HqPulse';
import { HqBroadcast } from './pages/stores/HqBroadcast';
import { HqPhotos } from './pages/stores/HqPhotos';
import { CommsDashboard } from './pages/comms/Dashboard';
import { CommsCallLog } from './pages/comms/CallLog';
import { HrDirectory } from './pages/hr/Directory';

export default function App() {
  return (
    <Routes>
      {/*
        /auth/callback is a public safety-net route. The auth-callback Lambda
        normally 302-redirects before the SPA loads. If the browser arrives
        here without a redirect, show a "Signing you in..." placeholder.
      */}
      <Route path="/auth/callback" element={<SigningIn />} />
      {/*
        /login is the email-first sign-in page. Public, OUTSIDE the Layout so
        AuthGate does not gate it. The user types their work email and the page
        routes by domain: @ampersandbrands.com -> Microsoft Entra,
        @lolliandpops.com -> Google. A one-click Microsoft button remains for
        HQ staff. AuthGate sends unauthenticated users here.
      */}
      <Route path="/login" element={<Login />} />
      {/*
        /signed-out is the landing page after a Cockpit local-logout. It sits
        OUTSIDE the Layout so it isn't gated by AuthGate (which would silent-
        SSO the user right back in and make sign-out feel broken).
      */}
      <Route path="/signed-out" element={<SignedOut />} />
      <Route element={<Layout />}>
        <Route path="/" element={<Home />} />

        {/* Reports landing page: one sidebar link, one card per report the
            user can open. Each report keeps its own route below. */}
        <Route path="/reports" element={<Reports />} />

        {/* Commerce. Orders is the primary surface; Inventory / Products /
            Partners / Reports ship as Planned stubs until each lands. */}
        <Route
          path="/commerce"
          element={<Navigate replace to="/commerce/orders" />}
        />
        <Route path="/commerce/orders" element={<CommerceOrders />} />
        <Route
          path="/commerce/orders/:orderId"
          element={<CommerceOrderDetail />}
        />
        <Route path="/commerce/products" element={<CommerceCatalogProducts />} />
        <Route
          path="/commerce/products/:itemCode"
          element={<CommerceCatalogProductDetail />}
        />
        <Route path="/commerce/inventory" element={<CommerceCatalogInventory />} />
        <Route path="/commerce/partners" element={<CommercePartnersStub />} />
        <Route path="/commerce/reports" element={<CommerceReportsStub />} />

        {/* Faire pages still mounted at their /sales/faire/* paths so the
            existing run / error / shipment surfaces stay reachable while we
            fold them into Commerce > Orders. The /sales/faire root redirects
            to Commerce Orders pre-filtered to channel=faire. */}
        <Route path="/sales/faire/dashboard" element={<FaireDashboard />} />
        <Route path="/sales/faire/reports" element={<FaireReports />} />
        <Route path="/sales/faire/errors" element={<FaireErrors />} />
        <Route path="/sales/faire/shipments" element={<FaireShipments />} />
        <Route
          path="/sales/faire"
          element={<Navigate replace to="/commerce/orders?channel=faire" />}
        />

        {/* IT / Projects tracker. Detail page removed 2026-05-23 — the card
            view is the only surface; cards click through to the SharePoint
            folder. /it/projects/{slug} legacy URLs redirect back to the list. */}
        <Route path="/it/projects" element={<Projects />} />
        <Route
          path="/it/projects/:slug"
          element={<Navigate replace to="/it/projects" />}
        />

        {/* Legacy URLs from the pre-departmental nav. Redirect into Commerce. */}
        <Route
          path="/faire/*"
          element={<Navigate replace to="/commerce/orders?channel=faire" />}
        />
        <Route
          path="/faire"
          element={<Navigate replace to="/commerce/orders?channel=faire" />}
        />

        {/* IT / Network monitor (netmon). Routes registered before the
            catch-all so /it/netmon/* resolves to the tool, not NotFound. */}
        <Route path="/it/netmon" element={<NetmonSites />} />
        <Route path="/it/netmon/snipeit" element={<NetmonSnipeItReconcile />} />
        <Route path="/it/netmon/:site_id" element={<NetmonSiteDetail />} />

        {/* Retail / Fleet Map. Project Possible weekly scorecard map.
            Gated by retail.scorecard.read; shows AccessDeniedCard otherwise. */}
        <Route path="/retail/fleet-map" element={<RetailFleetMap />} />

        {/* Retail / Allocation. Weekly warehouse-to-store allocation runs.
            Gated by retail.allocation.read; shows AccessDeniedCard otherwise. */}
        <Route path="/retail/allocation" element={<RetailAllocation />} />

        {/* Retail / OMNI Performance. Daily fleet report (Sales, Transactions,
            Traffic, Units, DPT/UPT) by region and store with both last-year
            bases. Gated by retail.omni.read (own-store via stores:store);
            shows AccessDeniedCard otherwise. */}
        <Route path="/retail/performance" element={<RetailPerformance />} />

        {/* Retail / Revenue Leakage. Categories and SKUs ranked by dollar
            decline vs the same trailing window last year. Gated in-component by
            retail.omni.read OR stores:store (mirrors OMNI Performance); shows
            AccessDeniedCard otherwise. */}
        <Route path="/retail/leakage" element={<RetailLeakage />} />

        {/* Retail / Item Sales. SKU-level daily sales: one row per store per
            SKU for a single day (units, net sales, cost, tickets). Gated
            in-component by retail.itemsales.read, which confers the FLEET view
            (no own-store path); shows AccessDeniedCard otherwise. */}
        <Route path="/retail/item-sales" element={<RetailItemSales />} />

        {/* Compliance / CoAs. Certificate-of-Analysis review grid + detail
            (embedded PDF + editable fields). Gated by the compliance.coas access slug.
            Registered before the /:dept/:tool catch-all. */}
        <Route
          path="/compliance"
          element={<Navigate replace to="/compliance/coas" />}
        />
        <Route path="/compliance/coas" element={<CoAsList />} />
        {/* Missing CoAs (Phase 2) registered before the /:documentId detail
            route so "missing" resolves to the view, not a document id. */}
        <Route path="/compliance/coas/missing" element={<MissingCoas />} />
        {/* Missing-PO detail. Four-segment path, registered before the
            three-segment /:documentId so it resolves to the PO detail. */}
        <Route path="/compliance/coas/missing/:id" element={<MissingCoaDetail />} />
        <Route path="/compliance/coas/:documentId" element={<CoaDetail />} />

        {/* Finance / Invoices. Vendor invoice review grid + detail (embedded
            PDF + editable fields). Gated by documents.read. Literal routes
            registered before the :documentId detail and the :dept/:tool
            catch-all. */}
        <Route
          path="/finance"
          element={<Navigate replace to="/finance/invoices" />}
        />
        <Route path="/finance/invoices" element={<InvoicesList />} />
        <Route path="/finance/invoices/:documentId" element={<InvoiceDetail />} />

        {/* CRM. Accounts / Pipeline / Wholesale Scorecard. Gated by crm:read
            (writes by crm:write). Literal routes registered before the detail
            :param routes and the /:dept/:tool catch-all. */}
        <Route path="/crm" element={<Navigate replace to="/crm/accounts" />} />
        <Route path="/crm/accounts" element={<CrmAccounts />} />
        <Route path="/crm/accounts/:accountId" element={<CrmAccountDetail />} />
        <Route path="/crm/opportunities" element={<CrmPipeline />} />
        <Route path="/crm/opportunities/:oppId" element={<CrmOpportunityDetail />} />
        <Route path="/crm/scorecard" element={<CrmScorecard />} />

        {/* IT / Cockpit Ops. Read-only live view of every scheduled job
            Cockpit owns. Registered before the /:dept/:tool catch-all. */}
        <Route path="/it/cockpit-ops" element={<CockpitOps />} />
        <Route path="/it/agents" element={<Agents />} />
        <Route path="/it/agents/:slug" element={<AgentDetail />} />

        {/* IT / Counter Validation. Cherry Creek 1173 people-counter
            validation: time-ordered traffic counts + entrance snapshots.
            Paired with api#428; degrades to empty state while that endpoint
            is not yet deployed. Registered before the /:dept/:tool catch-all. */}
        <Route path="/it/counter-validation" element={<CounterValidation />} />
        {/* IT / Notification log. Gated server-side by it.notifications. */}
        <Route path="/it/notifications" element={<NotificationLog />} />

        {/* IT / Telemetry. Canned CloudWatch Logs Insights reports over the API
            access log and the browser telemetry log group, so answering "who
            used what" or "which routes are slow" does not need AWS console
            access. Registered before the /:dept/:tool catch-all. */}
        <Route path="/it/telemetry" element={<Telemetry />} />
        {/* Per-user activity drill-down, reached by clicking a name on Activity
            by user. Not a catalog tool (no COCKPIT_DEPARTMENTS entry), so it is
            exempt from the Access-console parity test per cockpit-ui-navigation.md;
            it shares Telemetry's cockpit-ops gate through the parent page. */}
        <Route path="/it/telemetry/user" element={<UserActivityDetail />} />

        {/* IT / Adoption. How much of what we built is actually being used:
            per-tool usage against the people or stores who hold each tool.
            Backend /v1/adoption/* ships in parallel; degrades to a quiet
            "not available yet" state while it is not deployed. Registered
            before the /:dept/:tool catch-all. */}
        <Route path="/it/adoption" element={<Adoption />} />

        {/* IT / Changelog. Writes the What's new entries both Cockpit and The
            Sweet Spot show behind the avatar menu. Gated by it.changelog.
            Registered before the /:dept/:tool catch-all. */}
        <Route path="/it/changelog" element={<Changelog />} />

        {/* IT / Service Desk. The in-house ticket queue, the ticket workspace,
            the knowledge base, and the desk settings. Gated by it.servicedesk
            (SdShell shows an access card otherwise; the api enforces it too).
            Registered before the /:dept/:tool catch-all. */}
        <Route path="/it/service-desk" element={<ServiceDesk />} />
        <Route path="/it/service-desk/tickets/:id" element={<ServiceDeskTicket />} />
        <Route path="/it/service-desk/kb" element={<ServiceDeskKb />} />
        <Route path="/it/service-desk/kb/:id" element={<ServiceDeskKbArticle />} />
        <Route path="/it/service-desk/settings" element={<ServiceDeskSettings />} />
        {/* IT / API docs. Launch page for the api's Swagger UI (signed-in
            only since api #712). Gated by it.api-docs. Registered before the
            /:dept/:tool catch-all. */}
        <Route path="/it/api-docs" element={<ApiDocs />} />

        {/* Connect. Wholesale / broker partner-portal administration. Gated
            by the connect access scope; each page shows AccessDeniedCard
            otherwise. Literal + detail routes registered before the
            /:dept/:tool catch-all. The sidebar's Connect tools route here via
            toolHrefFor (connect-partners -> /connect, etc.). */}
        <Route path="/connect" element={<ConnectPartners />} />
        <Route path="/connect/partners/:id" element={<ConnectPartnerDetail />} />
        <Route path="/connect/pricing" element={<ConnectPricing />} />
        <Route path="/connect/catalog" element={<ConnectCatalog />} />
        <Route path="/connect/agreements" element={<ConnectAgreements />} />
        <Route path="/connect/adoption" element={<ConnectAdoption />} />

        {/* Stores. Store Operating System (Store Cockpit), Phase 1. Two
            audiences: store managers (mobile-first daily routine + thread,
            gated by stores:store) and HQ (compliance scorecard, question
            queue, broadcasts, per-store threads, gated by stores:hq). Literal
            routes registered before the /:dept/:tool catch-all. The sidebar
            routes the Stores tools here via toolHrefFor. */}
        {/* /stores is the store home: a tile menu of the store tools, and the
            landing page for store-only accounts (Home redirects them here;
            they live in the dedicated store shell without a sidebar). */}
        <Route path="/stores" element={<StoreHome />} />
        <Route path="/stores/today" element={<Today />} />
        {/* The store thread and the standalone chat window folded into the
            global chat bubble (shell/ChatBubbleMount). Old links redirect. */}
        <Route path="/stores/thread" element={<Navigate replace to="/stores" />} />
        <Route path="/stores/chat" element={<Navigate replace to="/stores" />} />
        {/* Inventory Count: mobile counting home + per-session scan loop. The
            literal /stores/inventory is registered before /stores/inventory/:id. */}
        <Route path="/stores/inventory" element={<InventoryCount />} />
        <Route path="/stores/inventory/:id" element={<CountSession />} />
        {/* Store user administration (stores:admin): assign accounts to stores. */}
        <Route path="/stores/users" element={<StoreUsers />} />
        <Route path="/stores/tablets" element={<StoreTablets />} />
        {/* Store Info (stores.info): one page per store, picked from a
            dropdown. The literal /stores/setup/info is registered before its
            Photos and Documents sub-page, which is reached from the tile on
            that page rather than the sidebar and is gated on the same slug. */}
        <Route path="/stores/setup/info" element={<StoreInfo />} />
        <Route path="/stores/setup/info/:store_no/files" element={<StoreFiles />} />
        {/* Paperwork tracker (stores.paperwork, ISD-575): per-store monthly counts of
            the invoices and licenses stores send from The Sweet Spot. */}
        <Route path="/stores/setup/paperwork" element={<StorePaperwork />} />
        {/* Store content editor (content:admin). Literal /stores/content is
            registered before the /new + /:id detail routes so the list resolves
            first, and all three sit before the /:dept/:tool catch-all. */}
        <Route path="/stores/content" element={<ContentList />} />
        <Route path="/stores/content/new" element={<ContentEditor />} />
        <Route path="/stores/content/:id" element={<ContentEditor />} />
        {/* HQ sub-tree. /stores/hq/questions and /stores/hq/broadcast are
            registered before /stores/hq/threads/:storeNo, and all before the
            catch-all, so the literal HQ pages resolve to their views. */}
        <Route path="/stores/hq" element={<HqScorecard />} />
        <Route path="/stores/door-times" element={<DoorTimes />} />
        <Route path="/stores/employee-purchases" element={<EmployeePurchases />} />
        <Route path="/reports/unposted-activity" element={<UnpostedActivity />} />
        <Route path="/reports/loyalty" element={<Loyalty />} />
        <Route path="/reports/store-analytics" element={<StoreAnalytics />} />
        <Route path="/reports/on-order" element={<OnOrder />} />
        <Route path="/reports/fleet-hourly" element={<FleetHourly />} />
        <Route path="/reports/cash-credit" element={<CashCredit />} />
        <Route path="/reports/trailing-12" element={<Trailing12 />} />
        <Route path="/reports/sales-tax" element={<SalesTax />} />
        <Route path="/reports/gift-cards" element={<GiftCards />} />
        <Route path="/reports/gl-exports" element={<GlExports />} />
        <Route path="/reports/item-file" element={<ItemFile />} />
        {/* Inventory Exports was renamed Item File (2026-11-03); keep old links working. */}
        <Route path="/reports/inventory-exports" element={<Navigate replace to="/reports/item-file" />} />
        <Route path="/stores/hq/inventory" element={<InventoryVariance />} />
        {/* Inventory Imports (Cockpit only, stores.imports.manage). Reached
            from the sidebar directly below Inventory variance. */}
        <Route path="/stores/hq/imports" element={<InventoryImports />} />
        {/* Variance history: reached from a link on Inventory variance, not
            from the sidebar, so it carries its own back link (stores:hq). */}
        <Route path="/stores/hq/inventory-history" element={<InventoryHistory />} />
        <Route path="/stores/hq/questions" element={<HqQuestions />} />
        <Route path="/stores/hq/pulse" element={<HqPulse />} />
        <Route path="/stores/hq/broadcast" element={<HqBroadcast />} />
        <Route path="/stores/hq/photos" element={<HqPhotos />} />
        {/* Checklist-definition admin (stores.users, shared with Store users).
            Reached from the Setup subgroup in the sidebar, not from the HQ
            scorecard sub-tree, even though it sits under /stores/hq. */}
        <Route path="/stores/hq/checklist" element={<StoreChecklist />} />
        {/* Per-store thread folded into the chat bubble; queue answers inline. */}
        <Route path="/stores/hq/threads/:storeNo" element={<Navigate replace to="/stores/hq/questions" />} />

        {/* Per-user settings, reached from the avatar menu in the header. Not a
            catalog tool (deliberately absent from COCKPIT_DEPARTMENTS), so it
            carries no capability gate beyond the signed-in session. */}
        <Route path="/settings" element={<SettingsPage />} />

        {/* What's new. The read-only changelog, also reached from the avatar
            menu. Not a catalog tool either, for the same reason /settings is
            not: every signed-in user can read it. */}
        <Route path="/changelog" element={<ChangelogPage />} />

        {/* Administration / Access. Per-tool access console. Gated by the
            access.admin capability; shows AccessDeniedCard otherwise.
            /admin and /administration redirect to the canonical path.
            Registered before the /:dept/:tool catch-all. */}
        <Route path="/admin/access" element={<AccessConsole />} />
        <Route path="/admin" element={<Navigate replace to="/admin/access" />} />
        <Route
          path="/administration"
          element={<Navigate replace to="/admin/access" />}
        />
        <Route
          path="/administration/access"
          element={<Navigate replace to="/admin/access" />}
        />

        {/* Comms. Dashboard (summary, callbacks, voicemail) + Call Log grid.
            Gated by comms:read (server-side). The sidebar routes the
            comms-dashboard and comms-calllog tools here via toolHrefFor.
            The bare /comms path redirects to the dashboard for old links. */}
        <Route path="/comms" element={<Navigate replace to="/comms/dashboard" />} />
        <Route path="/comms/dashboard" element={<CommsDashboard />} />
        <Route path="/comms/call-log" element={<CommsCallLog />} />

        {/* HR. One Directory, visible to every signed-in employee with no
            capability gate. It degrades gracefully (NotAvailableCard) when
            /v1/core/directory is not deployed or the roster has not been loaded
            on this stage. The bare /hr path redirects to it, and so does the old
            /hr/org-chart: the directory is already ordered by reporting line, so
            a second page rendering the same tree was retired rather than kept in
            sync. The redirect keeps existing bookmarks working. */}
        <Route path="/hr" element={<Navigate replace to="/hr/directory" />} />
        <Route path="/hr/directory" element={<HrDirectory />} />
        <Route path="/hr/org-chart" element={<Navigate replace to="/hr/directory" />} />

        {/* Catch-all for /{department}/{tool}/* — resolves to a NotFound
            placeholder until each tool ships a real page. The path params
            keep the sidebar's active-state logic working. */}
        <Route path="/:dept/:tool/*" element={<NotFound />} />
        <Route path="/:dept/:tool" element={<NotFound />} />
        <Route path="*" element={<NotFound />} />
      </Route>
    </Routes>
  );
}
